'use client';
import React, { useState } from 'react';
import MockExamIntro from './MockExamIntro';
import MockExamInterface from './MockExamInterface';
import PerformanceReport from './PerformanceReport';

export type MockExamPhase = 'intro' | 'exam' | 'report';

// Pre-filled mock results for demonstration of the report
export const MOCK_RESULTS = {
  rawScore: 32,
  totalQuestions: 40,
  timeTaken: 3547, // seconds
  passage1Score: 11,
  passage1Total: 13,
  passage2Score: 12,
  passage2Total: 13,
  passage3Score: 9,
  passage3Total: 14,
  byType: [
    { id: 'byt-mcq', type: 'Multiple Choice', correct: 8, total: 10, time: 82 },
    { id: 'byt-tfng', type: 'True/False/Not Given', correct: 5, total: 8, time: 97 },
    { id: 'byt-ynng', type: 'Yes/No/Not Given', correct: 3, total: 5, time: 106 },
    { id: 'byt-minfo', type: 'Matching Information', correct: 4, total: 5, time: 88 },
    { id: 'byt-mhead', type: 'Matching Headings', correct: 3, total: 6, time: 121 },
    { id: 'byt-mfeat', type: 'Matching Features', correct: 2, total: 3, time: 94 },
    { id: 'byt-mend', type: 'Matching Sentence Endings', correct: 2, total: 3, time: 87 },
    { id: 'byt-comp', type: 'Sentence Completion', correct: 3, total: 4, time: 92 },
    { id: 'byt-short', type: 'Short-Answer Questions', correct: 2, total: 2, time: 78 },
  ],
  errorRootCauses: [
    { id: 'erc-dist', cause: 'Distractor confusion', count: 5, pct: 63 },
    { id: 'erc-misloc', cause: 'Mis-location in passage', count: 2, pct: 25 },
    { id: 'erc-time', cause: 'Time-pressure guess', count: 1, pct: 12 },
  ],
  passageTimeBreakdown: [
    { id: 'ptb-p1', passage: 'Passage 1', allocated: 20, actual: 17, questions: 13 },
    { id: 'ptb-p2', passage: 'Passage 2', allocated: 20, actual: 22, questions: 13 },
    { id: 'ptb-p3', passage: 'Passage 3', allocated: 20, actual: 22, questions: 14 },
  ],
};

export default function MockExamScreen() {
  const [phase, setPhase] = useState<MockExamPhase>('intro');

  if (phase === 'intro') return <MockExamIntro onStartExam={() => setPhase('exam')} onViewReport={() => setPhase('report')} />;
  if (phase === 'exam') return <MockExamInterface onSubmit={() => setPhase('report')} />;
  return <PerformanceReport results={MOCK_RESULTS} onRetake={() => setPhase('intro')} />;
}